module.exports = __webpack_public_path__ + "img/UTECHO-3.1461ece0.jpg";